import { render, staticRenderFns } from "./UpdatePaymentBanner.vue?vue&type=template&id=4d402e28&"
import script from "./UpdatePaymentBanner.vue?vue&type=script&lang=js&"
export * from "./UpdatePaymentBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports